import React from 'react'
import { MessageCircle, Phone } from 'lucide-react'

export default function SMSContactAdmin() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="p-6">
          <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-[#DBEAFE] mx-auto">
            <MessageCircle className="w-8 h-8 text-blue-600" />
          </div>
          <h2 className="text-2xl font-bold text-center mb-2">Please Contact Admin</h2>
          <p className="text-gray-600 text-center mb-6">
            We need additional information. Please contact our admin team for assistance.
          </p>
          <div className="space-y-4">
            <button className="w-full py-2 px-4 bg-white border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none ">
              <Phone className="inline-block mr-2 h-4 w-4" /> Call Admin
            </button>
            <button className="w-full py-2 px-4 bg-[#2563EB] border border-transparent rounded-md text-sm font-medium text-white hover:bg-blue-700 focus:outline-none">
              <MessageCircle className="inline-block mr-2 h-4 w-4" /> Send SMS
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}